import React from "react";
import PropTypes from "prop-types";
import List from "@mui/material/List";
import Box from "@mui/material/Box";
import ContentListItem from "arena/components/ContentListItem";
import LoadMore from "core/components/LoadMore";

function ContentList({
  nodes,
  type,
  contentId,
  onClickItem,
  productId,
  collectionId,
  previewMode,
  hasMore,
  onLoadMore,
  loading,
  nextPage,
}) {
  return (
    <>
      <List disablePadding>
        {nodes.map((content) => (
          <ContentListItem
            key={content.id}
            selected={contentId === content.id}
            content={content}
            type={type}
            onClickItem={onClickItem}
            productId={productId}
            collectionId={collectionId}
            previewMode={previewMode}
          />
        ))}
      </List>

      {/* Показываем LoadMore компонент внизу списка */}
      {hasMore && !loading && (
        <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
          <LoadMore key={nextPage} onLoadMore={onLoadMore} />
        </Box>
      )}
    </>
  );
}

ContentList.propTypes = {
  collectionId: PropTypes.string,
  productId: PropTypes.string,
  type: PropTypes.string,
  onClickItem: PropTypes.func,
  contentId: PropTypes.string.isRequired,
  nodes: PropTypes.arrayOf(PropTypes.object).isRequired,
  previewMode: PropTypes.oneOf(["HORIZONTAL", "VERTICAL"]),
  hasMore: PropTypes.bool,
  onLoadMore: PropTypes.func,
  loading: PropTypes.bool,
  nextPage: PropTypes.number,
};

ContentList.defaultProps = {
  hasMore: false,
  onLoadMore: null,
  loading: false,
  nextPage: 0,
};

export default ContentList;
